import $ from 'jquery'

// Inline video for AI-* blocks: replaces the preview with the playing video

function getEmbed(url) {
  let match = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/)
  if (match) return { type: 'iframe', src: `https://www.youtube.com/embed/${match[1]}?autoplay=1&rel=0` }

  match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/)
  if (match) return { type: 'iframe', src: `https://player.vimeo.com/video/${match[1]}?autoplay=1` }

  if (/\.(mp4|webm|ogg|mov)(\?|$)/i.test(url)) return { type: 'video', src: url }

  return { type: 'iframe', src: url }
}

function play($button) {
  const $inner = $button.closest('.js-ai-video-inner')
  const embed = getEmbed($button.data('video'))

  const $player = embed.type === 'video'
    ? $('<video class="ai-video__player" controls autoplay playsinline></video>').attr('src', embed.src)
    : $('<iframe class="ai-video__player" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>').attr('src', embed.src)

  $inner.empty().append($player).addClass('is-playing')
}

export default function initAiVideo() {
  $(document).on('click', '.js-ai-video', function () {
    play($(this))
  })

  // External trigger (e.g. video title in AI - Hero)
  $(document).on('click', '.js-ai-video-trigger', function (e) {
    e.preventDefault()
    const $button = $(this).closest('.ai-hero__media').find('.js-ai-video').first()
    if ($button.length) play($button)
  })
}
